import React from 'react'
import { useTranslation } from 'react-i18next'
import { Subheader } from '../../Page/logix2020/Subheader'
import SubheaderForm from '../../Page/logix2020/SubheaderForm'


const EditSubheader = () => {
  const { t } = useTranslation()

  return (
    <Subheader className="subHeader-v1">
      <div className="flex-grow-1">
        <SubheaderForm
          title={t('assetSubheader:editAsset')}
          goBackLabel={t('assetSubheader:overviewAssets')}
        />
      </div>
    </Subheader>
  )
}

export default EditSubheader
